import { createFileRoute } from '@tanstack/react-router';

import { EsgPoliciesEvidenceWorkspace } from '@/features/esg/components/EsgPoliciesEvidenceWorkspace';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/datapoints-policies')({
  component: DmaDatapointsPoliciesRoute,
});

function DmaDatapointsPoliciesRoute() {
  return <EsgPoliciesEvidenceWorkspace />;
}
